import * as React from "react";
import { useContext, useEffect } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import { useLocation, useNavigate } from "react-router-dom";
import { Context, Menu } from "../../../context";

const Index = () => {
  const navigate = useNavigate();
  const [data, setData] = useContext(Context);
  const { pathname } = useLocation();
  useEffect(() => {
    setData({
      ...data,
      menu: data.menu.map((m: Menu) => {
        return {
          ...m,
          active: m.url.includes(pathname),
        };
      }),
    });
  }, [pathname]);

  return (
    <List>
      {data.menu.map(
        (item: Menu, index: number) =>
          !item.hidden && (
            <ListItem key={index} disablePadding>
              <ListItemButton
                onClick={() => navigate(item.url)}
                selected={item.active}
              >
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          )
      )}
    </List>
  );
};

export default Index;
